
exports.setupItemslideWidget = function setupItemslideWidget(UUID, siteID) {
	var scrollingParent = $("#scrollingParent_"+UUID);
	var carousel = $(".scrolling-items ul", scrollingParent);
	carousel.itemslide();

	$("#nextMap", scrollingParent).click(function() {NextSlide(carousel);});
	$("#previousMap", scrollingParent).click(function() {PreviousSlide(carousel);});

	$(".scrolling-items", scrollingParent).keydown(function(e) {
	  if(e.keyCode == 37) { // left
			PreviousSlide(carousel);
	  }
	  else if(e.keyCode == 39) { // right
			NextSlide(carousel);
	  }
	});
	carousel.on("pan", function(e) {
		carousel.data("isPanning", true);
	});

	carousel.on("changeActiveIndex", function(e) {
		//Cancel change if it's done by panning
		if (carousel.data("isPanning")) {
			carousel.data("isPanning", false);
			carousel.gotoSlide(carousel.data("prev-selection-index"));
		} else {
			ToggleDiv($(".itemslide-active", scrollingParent).val(), $("#scrollingContent_"+UUID)); // Activate the new active item when the a new item is active
			carousel.data("prev-selection-index", carousel.getActiveIndex());
		}
	});

	var firstSite = $(".scrolling-items ul li[value='"+siteID+"']", scrollingParent);
	var goToSlide = 0;
	if (typeof firstSite !== 'undefined') {
		goToSlide = $(firstSite).index();
	}
	carousel.data("prev-selection-index", goToSlide);
	carousel.gotoSlide(goToSlide);
}

function ToggleDiv(siteID, scrollingContent) {
	$("div[id^='Site_']", scrollingContent).css({ display: "none" });
	$("#Site_"+siteID, scrollingContent).css({ display: "inline-block" });
}

function NextSlide(carousel) {
	carousel.nextSlide();
}

function PreviousSlide(carousel) {
	carousel.previousSlide();
}
